
import { Component, Vue } from 'vue-property-decorator';

import Form7ProcessHeader from "@/components/process/Form7/components/Form7ProcessHeader.vue";
import Form7CaseInformation from "@/components/process/Form7/components/Form7CaseInformation.vue";
import { form7StatusInfoType } from '@/types/Information/Form7';

@Component({
    components:{
        Form7ProcessHeader,
        Form7CaseInformation
    }
})
export default class StartForm7 extends Vue {

    stepsCompleted = {} as form7StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }  


}
